import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useUserData from "../../../hooks/user/useUserData";

const TOKENS = {
    radius: 5,
    cardBg: "#FFFFFF",
    border: "#E9E9E9",
    label: "#111111",
    value: "#666666",
};

function chunkPairs(arr) {
    const out = [];
    for (let i = 0; i < arr.length; i += 2) out.push(arr.slice(i, i + 2));
    return out;
}

export default function ProductSpecsCard({
                                             title ,
                                             specs = [], // [{ label, value }]
                                         }) {
    const rows = chunkPairs(specs);
    const {language} = useUserData()

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                p: { xs: 2, md: 3 },
                minHeight: { xs: "auto", md: 260 },
            }}
        >
            <Typography
                sx={{
                    fontSize: { xs: 13, md: 14 },
                    fontWeight: 800,
                    letterSpacing: 0.3,
                    color: TOKENS.label,
                    textTransform: "uppercase",
                    mb: { xs: 1, md: 1.5 },
                }}
            >
                {title}
            </Typography>

            <Box
                sx={{
                    borderRadius: TOKENS.radius,
                    border: `1px solid ${TOKENS.border}`,
                    overflow: "hidden",
                    width: "100%",
                    backgroundColor: TOKENS.cardBg,
                }}
            >
                {rows.map((row, ri) => (
                    <Box
                        key={ri}
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "minmax(0,1fr) minmax(0,1fr)" },
                            borderBottom: ri < rows.length - 1 ? `1px solid ${TOKENS.border}` : "none",
                            backgroundColor: ri % 2 === 0 ? "#FFFFFF" : "#F9F9F9",
                            "& > .specCell:not(:first-of-type)": {
                                borderLeft: { xs: "none", sm: `0px solid ${TOKENS.border}` },
                            },
                        }}
                    >
                        {row.map((s, ci) => (
                            <Box
                                key={`${language === 'el'? s.labelEL : s.labelEN ?? ci}-${ci}`}
                                className="specCell"
                                sx={{
                                    p: { xs: 2, md: 2.5 },
                                    minWidth: 0,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: { xs: 12.5, md: 13 },
                                        fontWeight: 700,
                                        color: TOKENS.label,
                                        textTransform: "none",
                                        mb: 0.5,
                                        overflowWrap: "anywhere",
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {language === 'el'? s.labelEL : s.labelEN}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: { xs: 14, md: 14.5 },
                                        fontWeight: 500,
                                        color: TOKENS.value,
                                        lineHeight: 1.6,
                                        overflowWrap: "anywhere",
                                        wordBreak: "break-word",
                                        hyphens: "auto",
                                    }}
                                >
                                    {language === 'el'? s.valueEL : s.valueEN}
                                </Typography>
                            </Box>
                        ))}
                        {row.length === 1 && (
                            <Box
                                className="specCell"
                                sx={{
                                    display: { xs: "none", sm: "block" },
                                    p: { xs: 2, md: 2.5 },
                                }}
                            />
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
